"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("@material-ui/core/styles");
const Typography_1 = require("@material-ui/core/Typography");
const package_1 = require("../package");
const CollectAllStyles_1 = require("./jss/CollectAllStyles");
const CollectAll = ({ classes, collectThemAllBadge }) => {
    if (collectThemAllBadge !== null &&
        collectThemAllBadge !== undefined &&
        collectThemAllBadge > 0) {
        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.collectAll }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.checkIcon }, { children: (0, jsx_runtime_1.jsx)("img", { style: { width: '100%' }, src: package_1.assets.internalAssets.collectCheckLogoIcon }) })), (0, jsx_runtime_1.jsxs)(Typography_1.default, Object.assign({ className: classes.collectAllContent, variant: "overline" }, { children: ["Collected (", collectThemAllBadge, ")"] }))] })));
    }
    if (collectThemAllBadge !== undefined && collectThemAllBadge === 0) {
        return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.remainingAll }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ className: classes.remainingAllContent, variant: "overline" }, { children: "Remaining" })) })));
    }
    return null;
};
exports.default = (0, styles_1.withStyles)(CollectAllStyles_1.default)(CollectAll);
//# sourceMappingURL=CollectAll.js.map